import FuzzySearch from 'fuzzy-search';
import React, { FC, Fragment } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import theme from '@groove/ui/theme';

import MergeFieldMenuItem from './MergeFieldMenuItem';

import { MergeField, MergeFieldGroup } from '.';

interface MergeFieldSearchResultsProps {
  mergeFields: MergeFieldGroup[];
  onSelectMergeField: (mergeField: MergeField) => void;
  value: string;
}

const useStyles = makeStyles({
  label: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: 10,
    color: theme['neutral/600'],
    padding: '4px 8px',
    borderBottom: `1px solid ${theme['neutral/200']}`,
  },
});

const MergeFieldSearchResults: FC<MergeFieldSearchResultsProps> = ({
  mergeFields,
  onSelectMergeField,
  value,
}) => {
  const classes = useStyles({});
  const filteredMergeFields = mergeFields.map(section => ({
    ...section,
    options: new FuzzySearch(section.options, ['name', 'label'], {
      caseSensitive: false,
    }).search(value),
  }));

  return (
    <>
      {filteredMergeFields.map(section => (
        <Fragment key={section.label}>
          {section.options.length > 0 && (
            <Typography variant="caption" className={classes.label}>
              {section.label}
            </Typography>
          )}
          {section.options.map(mergeField => (
            <MergeFieldMenuItem
              onSelect={onSelectMergeField}
              key={mergeField.name}
              mergeField={mergeField}
            />
          ))}
        </Fragment>
      ))}
    </>
  );
};

export default MergeFieldSearchResults;
